/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Container, ContainerState } from '@adobe/aem-react-editable-components'
import { ButtonProps, ButtonTypes } from '@cox/core-ui8/dist/Button'
import { FormContainer, FormStatusPosition } from '@cox/core-ui8/dist/FormContainer'

import { FormContextItemType, ReactFormContainerProps } from './types'
import { getSpacing } from '../../utils/spacing-util'
import { DynamicBannerStatus, FormStateType } from '../../utils/types'
import IsInEditorText from '../shared/IsInEditorText'

import './ReactFormContainer.scss'

class ReactFormContainer extends Container<ReactFormContainerProps, ContainerState> {
  constructor(props: ReactFormContainerProps) {
    super(props)
  }

  get columnControlProps() {
    const attrs = this.containerProps
    attrs.className = `${attrs.className} ${this.props.baseCssClass}`
    attrs['data-cmp-is'] = 'formcontainer'
    return attrs
  }

  childComponentsKeys() {
    const items = this.props.cqItems
    const formItems: FormContextItemType[] = []
    Object.entries(items).forEach((entry) => {
      const [, value] = entry
      if (value) {
        let isRequired
        // @ts-expect-error Property 'required' or 'showRequiredText' does not exist on type 'Model'.
        if (value.required || value.showRequiredText) {
          isRequired = true
        } else {
          isRequired = false
        }

        formItems.push({
          // @ts-expect-error Properties 'name', 'value', and 'type' do not exist on type 'Model'.
          name: value.name,
          // @ts-expect-error Properties 'name', 'value', and 'type' do not exist on type 'Model'.
          value: value.value,
          isRequired: isRequired,
          // @ts-expect-error Properties 'name', 'value', and 'type' do not exist on type 'Model'.
          inputType: value.type,
          // @ts-expect-error Properties 'name', 'value', and 'type' do not exist on type 'Model'.
          parameters: value.parameters
        })
      }
    })
    return formItems
  }

  setDefaultState(formItems: Array<FormContextItemType>) {
    const state: FormStateType = {}
    formItems.forEach((formItem: FormContextItemType) => {
      state[formItem.name as keyof FormStateType] = {
        value: formItem.value,
        isRequired: formItem.isRequired,
        status: DynamicBannerStatus.PENDING,
        inputType: formItem.inputType,
        parameters: formItem.parameters
      }
    })
    return state
  }

  getFormButtons() {
    return [
      {
        isFormSubmit: true,
        buttonTypes: this.props.buttonTypes ?? ButtonTypes.PRIMARY,
        text: this.props.buttonText ?? 'Submit'
      }
    ] as Array<ButtonProps>
  }

  render(): JSX.Element {
    const formState = this.setDefaultState(this.childComponentsKeys())
    const formButtons = this.getFormButtons()
    const { top = false, right = false, bottom = false, left = false, lob = '' } = this.props
    return (
      <div
        className={`react-form-container ${getSpacing(top, right, bottom, left)} ${lob}`}
        data-testid='react-form-container'
        id={this.props.id}
      >
        {IsInEditorText(this.props.isInEditor, 'React Form Container')}
        <div className={`${this.props.baseCssClass ?? ''}`}>
          <FormContainer
            {...this.props}
            //@ts-ignore
            formState={formState}
            statusMessagePosition={this.props.statusMessageAtTop ? FormStatusPosition.TOP : FormStatusPosition.BOTTOM}
            formButtons={formButtons}
            withCredentials={false}
          >
            {this.childComponents}
            {this.placeholderComponent}
          </FormContainer>
        </div>
      </div>
    )
  }
}
export default ReactFormContainer
